export default "__VITE_ASSET__BZzJ00ri__"